import { ReduxState } from "../store";

export const selectNotification = (state: ReduxState) => state.general.notification;
export const selectCountries = (state: ReduxState) => state.general.countriesList;
export const selectStates = (state: ReduxState) => state.general.statesList;
export const selectCities = (state: ReduxState) => state.general.citiesList;
export const selectLegalTab = (state: ReduxState) => state.general.legalTab;
